export default "__VITE_ASSET__DgxEGs8n__"